import React, { useState, useEffect } from 'react'
import DropsFileIcon from '../Icons/DropsFileIcon'
import { ACCEPTED_IMAGE_TYPES } from '@/constants'

const DropUpload = ({
  className = '',
  draggedFiles = [],
  ...props
}) => {
  const [previewUrls, setPreviewUrls] = useState([]);
  
  // Generate preview URLs for image files
  useEffect(() => {
    const urls = [];
    
    // Only process up to 4 images for preview
    const imagesToPreview = draggedFiles
      .filter(file => ACCEPTED_IMAGE_TYPES.includes(file.type))
      .slice(0, 4);
    
    // Create object URLs for each image
    imagesToPreview.forEach(file => {
      const url = URL.createObjectURL(file);
      urls.push(url);
    });
    
    setPreviewUrls(urls);
    
    // Cleanup function to revoke object URLs
    return () => {
      urls.forEach(url => URL.revokeObjectURL(url));
    };
  }, [draggedFiles]);
  
  // Count file types
  const imageCount = draggedFiles.filter(file => 
    ACCEPTED_IMAGE_TYPES.includes(file.type)).length;
  const otherCount = draggedFiles.length - imageCount;
  
  return (
    <div className={`flex items-center justify-center p-v3-sm bg-v3-purple-bg w-full min-h-[96px] ${className} border-2 border-dashed border-v3-purple-primary rounded-v3-lg animate-fadeIn`} {...props}>
      {draggedFiles.length > 0 ? (
        <div className="flex flex-col items-center gap-v3-xs">
          {/* Preview grid for images */}
          {previewUrls.length > 0 && (
            <div className="flex flex-wrap gap-v3-xs justify-center mb-v3-xs max-w-[400px]">
              {previewUrls.map((url, index) => (
                <div 
                  key={index} 
                  className="w-16 h-16 rounded-v3-md overflow-hidden border border-v3-purple-primary"
                >
                  <img 
                    src={url} 
                    alt={`Preview ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
              
              {/* Show count if there are more images than previews */}
              {imageCount > previewUrls.length && (
                <div className="w-16 h-16 rounded-v3-md bg-v3-purple-lighter border border-v3-purple-primary flex items-center justify-center">
                  <span className="text-v3-purple-primary font-medium">
                    +{imageCount - previewUrls.length}
                  </span>
                </div>
              )}
            </div>
          )}
          
          {/* Status text */}
          <div className="flex items-center gap-v3-xs">
            <DropsFileIcon />
            <span className="text-sm font-medium font-inter-variable text-v3-purple-primary">
              {imageCount > 0 && otherCount > 0 ? 
                `Drop to add ${imageCount} image${imageCount !== 1 ? 's' : ''} and ${otherCount} file${otherCount !== 1 ? 's' : ''}` :
                imageCount > 0 ? 
                  `Drop to add ${imageCount} image${imageCount !== 1 ? 's' : ''}` :
                  `Drop to add ${otherCount} file${otherCount !== 1 ? 's' : ''}`
              }
            </span>
          </div>
        </div>
      ) : (
        <div className="flex items-center gap-v3-xs">
          <DropsFileIcon />
          <span className="text-sm font-medium font-inter-variable text-v3-purple-primary">
            Drop files here to add to chat
          </span>
        </div>
      )}
    </div>
  )
}

export default DropUpload